import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MsalGuard } from '@azure/msal-angular';
import { GroupGuardService } from './shared/group-guard.service';

import { HomeComponent } from './home/home.component';
import { ErrorComponent } from './error/error.component';
import { AppComponent } from './app.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ]
  },
  {
    // Needed for hash routing
    path: 'error',
    component: ErrorComponent
  },
  {
    // Needed for hash routing
    path: 'state',
    component: ErrorComponent
  },
  {
    // Needed for hash routing
    path: 'code',
    component: ErrorComponent
  },
  {
    path: '',
    component: AppComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
